import React, { useState } from "react"

import "./skillRating.css"
import { Headline } from "../headline/Headline"

export const SkillRating = ({ done, skill }) => {
  const [style, setStyle] = useState({})

  setTimeout(() => {
    const newStyle = {
      opacity: 1,
      width: `${done}%`,
    }

    setStyle(newStyle)
  }, 500)
  return (
    <div className="skill-rating__wrapper">
      <Headline level={3}>{skill}</Headline>
      <div className="skill-rating">
        <div className="skill-rating__done" style={style}>
          {done}%
        </div>
      </div>
    </div>
  )
}
